import Utils from './utils';

const ISO_CALENDAR_DATE = /^(\d{4})([-/])(\d{2})\2(\d{2})$/;

export const parseIsoCalendarDate = (text: string): Date | null => {
    const match = ISO_CALENDAR_DATE.exec(text.trim());
    if (!match) return null;

    const [, year, , month, day] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day));

    return Utils.formatLocalDateToYYYYMMDD(date) === `${year}-${month}-${day}` ? date : null;
};

const CALENDAR_DAY_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

const calendarDayParts = (text: string): [number, number, number] | null => {
    const match = CALENDAR_DAY_PREFIX.exec(text);
    return match ? [Number(match[1]), Number(match[2]), Number(match[3])] : null;
};

export const addCalendarDays = (text: string, days: number): string => {
    const parts = calendarDayParts(text);
    if (!parts) return '';

    const [year, month, day] = parts;
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
};

export const toLocalCalendarDate = (text: string): Date | null => {
    const parts = calendarDayParts(text);
    if (!parts) return null;

    const [year, month, day] = parts;
    return new Date(year, month - 1, day);
};
